type Props = {
  fill?: string;
  height?: string;
  width?: string;
};

const ShippingIcon = ({
  height = '32',
  width = '32',
  fill = '#FFAA00'
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.84314 2.76704C4.56155 3.24215 4.71842 3.85557 5.19353 4.13716L10.3551 7.19635C10.8302 7.47794 11.4436 7.32107 11.7252 6.84596L12.0651 6.27246C12.3467 5.79735 12.1898 5.18393 11.7147 4.90234L6.55317 1.84315C6.07806 1.56156 5.46464 1.71843 5.18305 2.19354L4.84314 2.76704ZM20.2244 5.45616L31.5786 10.6043C31.8031 10.7085 31.9931 10.8731 32.1268 11.0796C32.2605 11.2857 32.3319 11.5251 32.3333 11.77V25.5634C32.3319 25.8082 32.2605 26.0476 32.1268 26.2538C31.9931 26.4603 31.8031 26.6249 31.5786 26.729L20.2244 31.8772C19.871 32.041 19.4622 32.041 19.1088 31.8772L7.75463 26.729C7.53007 26.6249 7.34008 26.4602 7.20641 26.2538C7.07273 26.0476 7.00131 25.8082 6.99994 25.5634V11.77C7.00131 11.5252 7.07273 11.2858 7.20641 11.0796C7.34009 10.8731 7.53008 10.7085 7.75463 10.6043L19.1088 5.45616C19.4622 5.29241 19.871 5.29241 20.2244 5.45616ZM28.9862 11.5757L19.6666 7.33414L10.347 11.5757L19.6666 15.8173L28.9862 11.5757ZM18.6821 17.5011L8.96874 13.0976V25.1425L18.6821 29.5461V17.5011ZM20.651 17.5011V29.5461L30.3644 25.1425V13.0976L20.651 17.5011ZM1.2056 6.80796C0.728143 6.53038 0.566108 5.9183 0.843687 5.44084L1.17875 4.86449C1.45633 4.38703 2.06841 4.225 2.54587 4.50258L7.73298 7.51819C8.21044 7.79577 8.37248 8.40785 8.0949 8.88531L7.75983 9.46165C7.48225 9.93911 6.87017 10.1011 6.39271 9.82357L1.2056 6.80796ZM0.830041 10.8025C0.555683 11.2819 0.721838 11.8928 1.20116 12.1672L4.0941 13.8231C4.57342 14.0974 5.18439 13.9313 5.45875 13.452L5.78993 12.8734C6.06429 12.3941 5.89813 11.7831 5.41881 11.5087L2.52587 9.85284C2.04655 9.57848 1.43558 9.74464 1.16122 10.224L0.830041 10.8025Z"
        fill={fill}
      />
    </svg>
  );
};

export default ShippingIcon;
